/** @format */

import React, { useState } from "react";
import FaqCard from "./landing/FaqCard";
import Subtitle from "./landing/Subtitle";
import Title from "./landing/Title";

const faqs = [
  {
    title: "What is Fit-Stats",
    description:
      "Fit-Stats is a web-based platform that helps build and improve body shape and general fitness. It is designed for people who desire an athletic body, and for those who seek to reduce obesity, those whose aim is healthiness as they have their desired shape already. Not excluding, nursing mothers that might have a special take on our service to guide them through losing overdue belly fat after childbirth.",
    index: 1,
  },
  {
    title: "How is it different and what are the benefits?",
    description:
      "Fit-Stat, unlike others, will be using an individual unique method rather than a generalized approach to draft a workout plan that works for each person's body pattern.",
    index: 2,
  },

  {
    title: "How does it work?",
    description:
      "You can use Fit-Stats from anywhere using our web or mobile application.",
    index: 3,
  },

  {
    title: "How to get started?",
    description:
      "Subscribe to our platform and become part of other users who are building their fitness dreams with us.",
    index: 4,
  },

  {
    title: "Can I get a personalized body shape like a flat tummy?",
    description:
      "Of course, you can. We are here to provide you with exercise and diet plans throughout your companionship and journey with us.",
    index: 5,
  },

  {
    title: "Do I need to work out every day?",
    description:
      "One size does not fit all. There is more to exercise than health, some use it as recreation. We recommend you exercise at least 3 times a week, you may choose to increase this.",
    index: 6,
  },

  {
    title: "How long should my work out last?",
    description:
      "Again, one size doesn't fit all. The perfect individual timing is as: as much time as it takes to cover your exercise for the day. Otherwise, a session for 15 minutes at least, is recommended.",
    index: 7,
  },

  {
    title: "How long before I get a result or see changes?",
    description:
      "Results can vary according to consistency and body type. While physical changes are not instant magic, internal attentions are quiet, if you listen to your body after each workout session.",
    index: 8,
  },

  {
    title: "I tried accessing a plan but keep getting an error message",
    description:
      "Many things could prompt an error pop-up, some DIY is: to check your internet connection, clear your app cache, or restart your mobile device. If the situation persists, contact our customer support.",
    index: 9,
  },

  {
    title: "Can I track my Weight?",
    description:
      "Exercise is another way to increase muscles, and one of the constituents of weight is muscle. Follow up on your weight by using a scale for measurement weekly and update your profile with results.",
    index: 10,
  },

  {
    title: "What kind of support do I get as a Fit-Stats member?",
    description:
      "With us are exciting premium features that are not limited, giving you access to training guides, videos, opportunity to share routines and progress with friends.",
    index: 11,
  },

  {
    title: "Can I cancel my Subscription at any time?",
    description:
      "Your membership is voluntary, you may cancel any subscription you have with us at any point in time if you desire to terminate it.",
    index: 12,
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <div className="faq-bg pt-[64px] pb-[80px]" id="faq">
      <div className="flex flex-col justify-center items-center mb-[120px]">
        <Title title="FAQ" titleClass="title-text" />
        <Subtitle summary="What else would you like to know about FitStats?" />
      </div>
      <div className="grid xl:grid-cols-[1fr,1fr] md:grid-cols-[1fr,1fr] grid-cols-[1fr] gap-[30px] xl:px-28 md:px-12 px-6 ">
        {faqs &&
          faqs.map((faq, key) => (
            <FaqCard
              title={faq.title}
              description={faq.description}
              index={faq.index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              key={key}
            />
          ))}
      </div>
    </div>
  );
};

export default Faq;
